"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Ajax request class
 */
var EpsilonAjaxRequest = /** @class */ (function () {
    /**
     * Constructor
     * @param {Object} args
     */
    function EpsilonAjaxRequest(args) {
        this.args = args;
    }
    /**
     * Init Request
     */
    EpsilonAjaxRequest.prototype.request = function () {
        var self = this;
        jQuery.ajax({
            type: 'POST',
            data: { action: 'epsilon_framework_ajax_action', args: self.args },
            dataType: 'json',
            url: EpsilonWPUrls.ajaxurl,
            success: function (data) {
                self.result = data;
                jQuery(self).trigger('epsilon-received-success');
            },
            /**
             * Throw errors
             *
             * @param jqXHR
             * @param textStatus
             * @param errorThrown
             */
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
            }
        });
    };
    return EpsilonAjaxRequest;
}());
exports.EpsilonAjaxRequest = EpsilonAjaxRequest;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/utils/epsilon-ajax-request.ts
// module id = 0
// module chunks = 0 1 2